import gql from 'graphql-tag'

export default gql`mutation go($data: ProjectInput!){
  createSimpleProject(data: $data){
    project_id
  }
}`